/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlIPInfoMetadataImpl } from './ControlIPInfoMetadataImpl';
import {
    ControlIPInfoMetadataImplFromJSON,
    ControlIPInfoMetadataImplFromJSONTyped,
    ControlIPInfoMetadataImplToJSON,
} from './ControlIPInfoMetadataImpl';

/**
 * 
 * @export
 * @interface ControlIP
 */
export interface ControlIP {
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    ipv4?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    ipv6?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    locationId?: string;
    /**
     * 
     * @type {ControlIPInfoMetadataImpl}
     * @memberof ControlIP
     */
    metadata: ControlIPInfoMetadataImpl;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    metadataLastFetchedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIP
     */
    updatedAt: string;
}

/**
 * Check if a given object implements the ControlIP interface.
 */
export function instanceOfControlIP(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "metadataLastFetchedAt" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function ControlIPFromJSON(json: any): ControlIP {
    return ControlIPFromJSONTyped(json, false);
}

export function ControlIPFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'displayName': json['displayName'],
        'id': json['id'],
        'ipv4': !exists(json, 'ipv4') ? undefined : json['ipv4'],
        'ipv6': !exists(json, 'ipv6') ? undefined : json['ipv6'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'metadata': ControlIPInfoMetadataImplFromJSON(json['metadata']),
        'metadataLastFetchedAt': json['metadataLastFetchedAt'],
        'teamId': json['teamId'],
        'updatedAt': json['updatedAt'],
    };
}

export function ControlIPToJSON(value?: ControlIP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'displayName': value.displayName,
        'id': value.id,
        'ipv4': value.ipv4,
        'ipv6': value.ipv6,
        'locationId': value.locationId,
        'metadata': ControlIPInfoMetadataImplToJSON(value.metadata),
        'metadataLastFetchedAt': value.metadataLastFetchedAt,
        'teamId': value.teamId,
        'updatedAt': value.updatedAt,
    };
}

